/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsStep_4Aliases {
  DYNAMIC_FIELDS_QUIZ = 'dynamic-fields-quiz',
  FORM_QUIZ = 'form-quiz',
  LAYOUT_QUIZ = 'layout-quiz',
  PANEL_QUIZ = 'panel-quiz',
}
export { PseudonymAppointmentsStep_4Aliases };
